import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Card,
    CardContent,
    CircularProgress,
    IconButton,
    Typography
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import MusicianContext from 'src/musicianContext';
import {deleteSong} from './helperFx';
import MusicSnackbar from 'src/components/MusicSnackbar';

const SongUploader = ({ className, music, isLoading, updateMusicView, ...rest }, props) => {
    const musician = useContext(MusicianContext);
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const [deletedSongName, setDeletedSongName] = useState();

    const handleDeleteButtonClick = async (track) => {
        await deleteSong(musician.musician, track.name);
        await updateMusicView();
        setDeletedSongName(track.name);
        setIsSnackbarOpen(true);
    };

    return (
        <Card {...rest}>
            <CardContent>
                <Box alignItems="center" display="flex" flexDirection="column">
                    <Typography color="textPrimary" gutterBottom variant="h3">
                        My Music
                    </Typography>
                </Box>
                <Box alignItems="center" display="flex" flexDirection="column">
                { 
                    isLoading ?
                    <CircularProgress color="primary" /> :
                    ( 
                        music.length ?
                        music.map((track, index) => 
                            <Box mt={1} alignItems="center" display="flex" flexDirection="column">
                                <Typography color="textPrimary" gutterBottom variant="h5">
                                    {track.name}
                                </Typography>
                                <Box display="flex" flexDirection="row">
                                    <audio id="player" key={index} src={track.url} controls />
                                    <IconButton color="primary" onClick={async () => await handleDeleteButtonClick(track)} aria-label="delete">
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                        ) :
                        <Typography color="textSecondary" gutterBottom variant="h5">
                            You don't have any music yet. Uploaded tracks will appear here.
                        </Typography>
                    )
                }
                </Box>
            </CardContent>
            <MusicSnackbar 
                text={`Success! Deleted ${deletedSongName}`}
                setOpen={setIsSnackbarOpen}
                open={isSnackbarOpen}
                severity="error"
            />
        </Card>
    );
};

SongUploader.propTypes = {
  className: PropTypes.string
};

export default SongUploader;
